import React from "react";

import heroImage from "../img/images/hero.png";
import arrowBottomWhite from "../img/icons/arrow-bottom-white.svg";
import uaFlag from "../img/icons/ua-flag.png";

import blueRing75 from "../img/decor/blue-ring75-1.svg";
import blueRing50 from "../img/decor/blue-ring50-1.svg";
import orangeRing50 from "../img/decor/orange-ring50-1.svg";
import orangeRing25 from "../img/decor/orange-ring25-1.svg";
import greenRing50 from "../img/decor/green-ring50-1.svg";
import greenRing50two from "../img/decor/green-ring50-2.svg";

import SectionHeader from "../components/section-header";
import Button from "../components/button";

import { Parallax } from "react-scroll-parallax";
import GsapMagnetic from "../components/GsapMagnetic";
import RecentWorks from "../components/recent-works";
import Reviews from "../components/reviews";
import AboutQoute from "../components/aboutQuote";

function Home({
  projects,
  setModal,
  modal,
  setScrollTargetMarker,
  scrollReady,
}) {

  const scrollDown = () => {
    setScrollTargetMarker(true);
  };

  return (
    <div>
      <section className="main__hero hero">
        <div className="hero__container-small">
          <div className="hero__wrapper">
            <img
              src={blueRing75}
              alt=""
              className="hero__decor hero__decor-blue anim-circle-type1"
            />
            <img
              src={orangeRing50}
              alt=""
              className="hero__decor hero__decor-orange anim-circle-type2"
            />
            <img
              src={greenRing50}
              alt=""
              className="hero__decor hero__decor-green anim-circle-type3"
            />

            <div className="hero__article">
              <Parallax speed={5}>
                <h1
                  className="hero__title title title_hero"
                  data-aos="fade-right"
                  data-aos-duration="1000"
                  data-aos-delay="300">
                  Hi, my name is <span>Dima</span>
                </h1>
              </Parallax>
              <Parallax speed={6}>
                <button
                  className="hero__scroll-down"
                  onClick={() => scrollDown()}
                  data-aos="fade-right"
                  data-aos-duration="1000"
                  data-aos-delay="400">
                  scroll down
                </button>
              </Parallax>
            </div>
            <div
              className="hero__preview"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-easing=".71,.17,.28,.83">
              <Parallax speed={8}>
                <div className="hero__image">
                  <img src={heroImage} alt="Dima Dziubenko" />
                </div>
              </Parallax>

              <div
                className="hero-label hero-label_blue"
                data-aos="fade-down"
                data-aos-duration="600"
                data-aos-delay="1200">
                <div className="hero-label__wrapper">Frontend developer</div>
              </div>
              <div
                className="hero-label hero-label_red"
                data-aos="fade-down"
                data-aos-duration="600"
                data-aos-delay="1200">
                <div className="hero-label__wrapper">Designer</div>
              </div>
            </div>

            <GsapMagnetic>
              <button
                className={`hero-scroll-btn ${scrollReady ? "hidden" : ""}`}
                onClick={() => scrollDown()}>
                <img src={arrowBottomWhite} alt="scroll bottom" />
              </button>
            </GsapMagnetic>
          </div>
        </div>
      </section>

      <section className="main__about about">
        <Parallax speed={8}>
          <SectionHeader title="About me" />
        </Parallax>
        <div className="about__container-small">
          <div className="about__wrapper">
            <div className="about-preview">
              <Parallax speed={6}>
                <svg
                  viewBox="0 0 555 697"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_153_98)">
                    <g opacity="0.3">
                      <path
                        d="M148.164 668.431C175.927 664.928 201.69 655.33 229.886 652.282C264.357 648.551 292.348 669.409 322.09 677.348C317.724 683.398 288.801 687.97 278.137 690.108C261.901 693.383 243.21 696.613 225.679 696.977C199.348 697.523 181.589 686.241 161.466 677.416L164.308 678.803"
                        fill="#77B7B6"
                      />
                    </g>
                    <path
                      d="M37.7231 165.271C41.9929 165.271 45.4542 161.809 45.4542 157.538C45.4542 153.266 41.9929 149.804 37.7231 149.804C33.4534 149.804 29.9921 153.266 29.9921 157.538C29.9921 161.809 33.4534 165.271 37.7231 165.271Z"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <g className="frame1-about">
                      <path
                        opacity="0.3"
                        d="M86.0195 115.799L146.004 145.596L168.378 100.878L106.234 71.4901C106.234 71.4901 98.6394 101.287 86.0195 115.799Z"
                        fill="#77B7B6"
                      />
                      <path
                        d="M112.805 83.0905L107.621 94.8728L121.15 101.333L127.995 89.6867L112.805 83.0905Z"
                        fill="white"
                      />
                      <path
                        d="M148.323 91.6884L125.857 135.611"
                        stroke="white"
                        strokeWidth="2.51"
                        strokeMiterlimit="10"
                      />
                      <path
                        d="M156.213 95.2595L133.748 139.182"
                        stroke="white"
                        strokeWidth="2.51"
                        strokeMiterlimit="10"
                      />
                      <path
                        d="M86.0195 115.799L146.004 145.596L168.378 100.878L106.234 71.4901C106.234 71.4901 98.6394 101.287 86.0195 115.799Z"
                        stroke="#232144"
                        strokeWidth="0.84"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M112.805 83.0905L107.621 94.8728L121.15 101.333L127.995 89.6867L112.805 83.0905Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M106.348 101.333L134.953 115.435"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M104.824 105.017L116.466 110.59"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M101.8 109.453L126.721 121.372"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <path
                      d="M175.382 181.58C171.266 177.463 178.656 193.044 183.408 196.41C188.161 199.776 194.391 200.891 200.098 199.708V180.92C200.098 180.92 175.609 181.83 175.382 181.58Z"
                      fill="#89694E"
                    />
                    <path
                      d="M175.382 181.58C175.473 187.403 178.656 193.044 183.408 196.41C188.161 199.776 194.391 200.891 200.098 199.708"
                      fill="#89694E"
                    />
                    <path
                      d="M175.382 181.58C175.473 187.403 178.656 193.044 183.408 196.41C188.161 199.776 194.391 200.891 200.098 199.708"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M271.975 654.192L272.52 675.755C272.202 678.189 273.043 680.6 274.771 682.329C275.635 683.193 276.659 683.83 277.796 684.24C291.166 688.834 299.625 691.973 313.7 693.611L318.406 694.157L322.954 694.407L327.797 694.043C334.778 693.202 341.6 691.291 348.035 688.379C350.058 683.967 349.058 678.735 345.511 675.437C337.78 668.249 322.477 656.308 300.784 650.189L294.099 639.817C298.124 641.773 300.784 645.071 300.784 648.824C300.784 654.807 294.054 659.674 285.731 659.674C277.409 659.674 270.678 654.807 270.678 648.824C270.678 645.572 272.657 642.66 275.817 640.659"
                      fill="#2E4C64"
                    />
                    <path
                      d="M348.899 683.853C348.899 685.445 348.558 687.06 347.853 688.584C341.44 691.496 334.596 693.383 327.616 694.248L322.772 694.612L318.202 694.361L313.495 693.816C299.443 692.178 290.984 689.062 277.614 684.444C276.477 684.058 275.431 683.398 274.589 682.556C272.861 680.828 272.02 678.394 272.338 675.983L272.179 669.318C279.797 676.188 293.826 681.237 310.084 682.124C324.137 682.898 336.87 680.373 345.442 675.778C347.694 677.939 348.899 680.896 348.899 683.876V683.853Z"
                      fill="#1E3C51"
                    />
                    <path
                      d="M179.202 638.452C175.177 640.204 172.517 643.206 172.517 646.618C172.517 652.032 179.247 656.422 187.569 656.422C195.892 656.422 202.622 652.032 202.622 646.618C202.622 643.684 200.644 641.045 197.483 639.249L202.327 649.143L204.259 670.865C204.532 673.868 203.964 676.87 202.622 679.554L202.327 680.123C190.23 684.399 177.701 687.31 164.945 688.789L152.689 689.176C146.617 688.425 140.683 686.787 135.112 684.262C133.361 680.418 134.225 675.892 137.317 673.003C143.843 666.93 156.577 656.99 174.563 651.531L179.224 638.475L179.202 638.452Z"
                      fill="#2E4C64"
                    />
                    <path
                      d="M180.248 656.672C180.248 656.672 187.569 659.151 194.778 656.672"
                      stroke="#1E3C51"
                      strokeWidth="1.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M203.168 678.758L202.44 680.236C190.344 684.513 178.11 687.561 165.377 689.039L160.238 689.699L152.62 689.517C146.549 688.766 140.797 686.878 135.226 684.376C134.612 683.057 134.316 681.647 134.316 680.259C134.316 677.598 135.385 675.005 137.408 673.117C137.522 673.026 137.613 672.935 137.727 672.821C148.096 678.326 163.467 680.737 180.134 678.599C189.093 677.461 197.37 675.141 204.441 672.002C204.646 674.323 204.214 676.688 203.168 678.758Z"
                      fill="#1E3C51"
                    />
                    <g className="frame1-about">
                      <path
                        opacity="0.58"
                        d="M440.307 343.485H322.863C319.422 343.485 316.633 346.275 316.633 349.717V434.013C316.633 437.455 319.422 440.245 322.863 440.245H440.307C443.748 440.245 446.538 437.455 446.538 434.013V349.717C446.538 346.275 443.748 343.485 440.307 343.485Z"
                        fill="#E0F3FC"
                      />
                      <path
                        className="frame-sun-mirror"
                        d="M365.725 343.894L327.797 440.245L362.746 440.495L394.398 343.985H394.353C394.353 343.985 366.657 343.485 365.748 343.871L365.725 343.894Z"
                        fill="#EFFDFD"
                      />
                      <path
                        className="frame-sun-mirror"
                        d="M399.674 343.894L367.112 440.245H375.73L408.155 343.735H405.381C405.381 343.735 400.606 343.485 399.696 343.871L399.674 343.894Z"
                        fill="white"
                      />
                      <path
                        d="M365.93 383.767L352.514 391.501L339.099 399.257V383.767V368.255L352.514 376.011L365.93 383.767Z"
                        fill="white"
                      />
                      <path
                        d="M420.525 383.472H388.259C387.518 383.472 386.917 384.073 386.917 384.814V412.518C386.917 413.259 387.518 413.86 388.259 413.86H420.525C421.266 413.86 421.866 413.259 421.866 412.518V384.814C421.866 384.073 421.266 383.472 420.525 383.472Z"
                        fill="#FFA744"
                      />
                      <path
                        d="M386.917 407.673H421.866V411.904C421.866 412.996 420.98 413.86 419.911 413.86H388.896C387.804 413.86 386.94 412.973 386.94 411.904V407.673H386.917Z"
                        fill="#F97C00"
                      />
                      <path
                        d="M391.238 384.745H410.042"
                        stroke="#FFDAB6"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M398.173 384.745H403.016"
                        stroke="white"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M387.031 400.85V393.207"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M387.031 389.499V384.859C387.031 384.109 387.645 383.517 388.373 383.517H420.616C421.366 383.517 421.957 384.131 421.957 384.859V412.541C421.957 413.291 421.343 413.883 420.616 413.883H388.373C387.622 413.883 387.031 413.269 387.031 412.541V404.876"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M408.906 358.065L438.238 358.156"
                        stroke="#ACD9EA"
                        strokeWidth="2.66"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M328.889 358.065L347.034 357.928"
                        stroke="#ACD9EA"
                        strokeWidth="2.66"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M440.307 343.485H322.863C319.422 343.485 316.633 346.275 316.633 349.717V434.013C316.633 437.455 319.422 440.245 322.863 440.245H440.307C443.748 440.245 446.538 437.455 446.538 434.013V349.717C446.538 346.275 443.748 343.485 440.307 343.485Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M316.633 355.585H446.538"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M339.099 404.284H371.819"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M339.099 408.833H359.427"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M339.099 413.405H359.427"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M365.93 383.767L352.514 391.501L339.099 399.257V383.767V368.255L352.514 376.011L365.93 383.767Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M326.069 350.99C327.149 350.99 328.025 350.115 328.025 349.034C328.025 347.954 327.149 347.078 326.069 347.078C324.989 347.078 324.114 347.954 324.114 349.034C324.114 350.115 324.989 350.99 326.069 350.99Z"
                        stroke="#232144"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M333.869 350.99C334.949 350.99 335.824 350.115 335.824 349.034C335.824 347.954 334.949 347.078 333.869 347.078C332.789 347.078 331.913 347.954 331.913 349.034C331.913 350.115 332.789 350.99 333.869 350.99Z"
                        stroke="#232144"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M341.827 350.99C342.907 350.99 343.783 350.115 343.783 349.034C343.783 347.954 342.907 347.078 341.827 347.078C340.747 347.078 339.872 347.954 339.872 349.034C339.872 350.115 340.747 350.99 341.827 350.99Z"
                        stroke="#232144"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <path
                      opacity="0.34"
                      d="M402.766 151.191C408.794 151.191 413.68 146.303 413.68 140.273C413.68 134.244 408.794 129.355 402.766 129.355C396.738 129.355 391.852 134.244 391.852 140.273C391.852 146.303 396.738 151.191 402.766 151.191Z"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      opacity="0.54"
                      d="M402.766 155.832C411.356 155.832 418.319 148.866 418.319 140.273C418.319 131.681 411.356 124.715 402.766 124.715C394.176 124.715 387.213 131.681 387.213 140.273C387.213 148.866 394.176 155.832 402.766 155.832Z"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M431.247 94.3559L388.988 106.445C387.346 106.915 386.395 108.628 386.865 110.27L397.213 146.464C397.682 148.106 399.394 149.057 401.036 148.587L443.295 136.498C444.937 136.028 445.888 134.315 445.418 132.673L435.071 96.4795C434.601 94.8369 432.889 93.8861 431.247 94.3559Z"
                      fill="white"
                    />
                    <path
                      d="M70.3527 229.119C67.5331 221.521 60.2568 213.674 60.2568 213.674L62.7581 216.631L65.3048 190.246L42.2707 158.334L40.679 156.559C39.0873 154.785 38.5871 155.354 38.5871 155.354L36.4497 155.786C34.5397 157.174 35.1763 160.085 35.1763 160.085L36.5179 163.383L47.5915 186.061L43.4076 184.673C37.5866 186.311 36.4497 192.407 36.4497 192.407V203.802C36.4497 203.802 52.9805 216.927 53.5717 231.507L64.1678 236.102L70.33 229.141L70.3527 229.119Z"
                      fill="#FFB999"
                    />
                    <path
                      d="M55.0953 230.119C54.3449 214.425 38.7236 203.802 38.7236 203.802L38.5872 192.407C38.5872 192.407 39.0874 187.971 43.2713 186.334"
                      stroke="#F57A59"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M381.756 213.015C373.206 235.237 332.573 277.977 332.573 277.977L333.164 278.386C298.215 254.571 252.829 238.399 240.459 234.214C238.367 233.509 236.162 233.145 233.956 233.145H211.922L189.434 241.197L160.397 265.239L131.451 284.505L71.4215 227.754C62.3489 235.351 49.1378 229.755 48.6376 229.551L109.668 318.965H118.763C134.68 318.965 150.324 314.711 164.081 306.636L167.651 304.521V296.674L172.221 357.473L180.316 349.876L165.65 364.57V380.401L172.994 387.111L163.444 395.481L166.15 413.2L169.197 414.429C186.683 421.457 205.192 424.96 223.678 424.96C243.233 424.96 262.788 421.025 281.115 413.2L288.96 398.507L287.619 391.501L282.889 394.23L282.616 393.594L280.843 385.837L274.931 380.424L274.021 379.104L271.406 336.32C271.406 335.569 271.543 334.841 271.793 334.159L278.046 317.077C278.296 316.371 278.432 315.644 278.432 314.916V295.878L346.125 313.301C350.195 314.347 354.447 312.459 356.38 308.729L401.129 222.954C390.874 222.568 381.756 213.083 381.756 213.083V213.015Z"
                      fill="#C48E78"
                    />
                    <path
                      d="M151.484 273.7L161.17 267.627L181.294 250.727"
                      stroke="#A75363"
                      strokeOpacity="0.33"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M384.484 215.858V171.89L399.196 138.567L400.947 136.725C400.947 136.725 404.403 133.882 406.427 136.725C408.451 139.568 407.109 143.276 407.109 143.276L405.881 145.641L394.603 170.457L396.672 166.158H406.427L409.588 168.683L416.182 178.304L414.658 190.974L405.54 203.893L396.695 222.591"
                      fill="#FFB999"
                    />
                    <path
                      d="M386.213 177.395V196.774"
                      stroke="#FCE6ED"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M395.899 219.11L403.494 203.166L412.612 190.496"
                      stroke="#F57A59"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M222.791 243.858C216.993 243.858 210.99 238.922 212.286 233.349V205.258H233.296L233.592 233.622C233.592 241.606 233.296 243.858 222.791 243.858Z"
                      fill="#FFB999"
                    />
                    <path
                      d="M211.695 225.548C211.695 225.548 222.041 232.485 233.524 225.548V211.764H211.786C211.786 211.764 211.217 225.548 211.695 225.548Z"
                      fill="#F57A59"
                    />
                    <path
                      d="M277.773 664.064L270.929 650.189L274.157 644.685L278.705 635.564L288.96 634.608L297.896 644.48L306.833 658.924C306.833 658.924 298.283 665.952 297.328 666.134"
                      fill="#2E4C64"
                    />
                    <path
                      d="M179.202 638.452C175.177 640.203 172.517 643.206 172.517 646.618C172.517 652.031 179.247 656.421 187.569 656.421C195.892 656.421 202.622 652.031 202.622 646.618C202.622 643.684 199.212 639.476 194.8 637.77L182.703 637.292L179.224 638.452H179.202Z"
                      fill="#2E4C64"
                    />
                    <path
                      d="M274.453 633.175L278.455 647.733C278.91 649.416 280.342 650.69 282.093 650.872C284.867 651.167 289.119 650.963 292.439 648.051C293.508 647.119 294.008 645.663 293.826 644.253L292.03 631.219"
                      fill="#FFB999"
                    />
                    <path
                      d="M271.793 621.416L275.795 635.973C276.249 637.656 277.682 638.93 279.433 639.112C282.207 639.408 286.459 639.203 289.779 636.291C290.847 635.359 291.348 633.903 291.166 632.493L289.369 619.459"
                      fill="#F57A59"
                    />
                    <path
                      d="M182.681 633.994V645.504C182.681 645.504 188.775 649.803 194.846 645.504V633.266"
                      fill="#FFB999"
                    />
                    <path
                      d="M182.681 626.397V637.906C182.681 637.906 188.775 642.205 194.846 637.906V625.669"
                      fill="#F57A59"
                    />
                    <path
                      d="M79.5164 238.763L122.037 279.796"
                      stroke="#A85E6C"
                      strokeOpacity="0.44"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M300.443 627.148C280.706 639.681 268.905 630.946 268.905 630.946L263.584 592.938L248.008 533.708L227.885 466.835L202.804 631.151C176.609 640.659 168.628 626.033 168.628 626.033L170.538 415.543C205.146 428.349 246.098 428.508 280.229 414.292L300.443 627.148Z"
                      fill="#84ECFF"
                    />
                    <path
                      opacity="0.5"
                      d="M201.167 425.802C196.142 472.749 195.187 573.786 190.025 634.358C173.563 634.745 168.628 626.033 168.628 626.033L170.607 415.111C185.705 420.707 185.341 425.392 201.167 425.824V425.802Z"
                      fill="#29AFD3"
                    />
                    <path
                      d="M223.974 474.91L217.903 516.489"
                      stroke="#29AFD3"
                      strokeWidth="2.66"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M250.805 537.779L263.47 584.727"
                      stroke="#29AFD3"
                      strokeWidth="2.66"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M211.24 556.385L205.169 597.965"
                      stroke="#29AFD3"
                      strokeWidth="2.66"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M179.111 420.729C192.049 425.165 234.479 436.742 279.865 417.045"
                      stroke="#29AFD3"
                      strokeWidth="2.66"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M192.708 429.259C197.802 430.396 203.827 431.465 210.581 432.148"
                      stroke="#29AFD3"
                      strokeWidth="2.66"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M57.8466 239.9L105.461 309.548"
                      stroke="#A97763"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M342.6 270.789L360.2 250.158L367.408 241.037"
                      stroke="#965A65"
                      strokeOpacity="0.38"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M253.079 241.606C253.079 241.606 294.667 256.414 320.112 272.95"
                      stroke="#965A65"
                      strokeOpacity="0.38"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M271.11 248.589C275.84 250.522 281.161 252.797 286.732 255.299"
                      stroke="#FCE6ED"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M280.047 294.786L344.897 311.231"
                      stroke="#A97763"
                      strokeOpacity="0.43"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M386.781 246.724L356.402 303.725"
                      stroke="#A97763"
                      strokeOpacity="0.43"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M165.832 301.291C158.146 305.931 149.937 309.525 141.274 311.891C132.611 314.256 124.016 315.78 115.466 315.03C112.555 314.779 112.578 319.306 115.466 319.579C124.379 320.352 133.907 318.623 142.479 316.281C151.484 313.824 160.124 310.048 168.105 305.226C170.607 303.725 168.333 299.79 165.809 301.314L165.832 301.291Z"
                      fill="#A97763"
                    />
                    <path
                      d="M166.195 297.856C154.258 305.067 140.865 309.73 126.994 311.231C124.129 311.549 124.084 316.099 126.994 315.78C141.683 314.188 155.827 309.434 168.492 301.769C170.993 300.267 168.719 296.332 166.195 297.856Z"
                      fill="#A97763"
                    />
                    <path
                      d="M166.786 292.807C158.055 298.402 148.55 302.542 138.523 305.112C135.703 305.84 136.885 310.207 139.728 309.48C150.119 306.818 160.056 302.497 169.083 296.719C171.539 295.15 169.265 291.215 166.786 292.807Z"
                      fill="#A97763"
                    />
                    <path
                      d="M167.287 288.508C158.555 294.103 149.05 298.243 139.023 300.813C136.203 301.541 137.386 305.908 140.228 305.181C150.619 302.519 160.556 298.198 169.583 292.42C172.039 290.851 169.765 286.916 167.287 288.508Z"
                      fill="#A97763"
                    />
                    <path
                      d="M283.412 481.097L286.732 517.035"
                      stroke="white"
                      strokeWidth="3.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M290.234 554.202L293.576 590.14"
                      stroke="white"
                      strokeWidth="3.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M272.588 356.017L274.066 379.537L274.976 380.879L280.888 386.292L282.662 394.026L282.934 394.663L287.664 391.933L289.006 398.939L281.161 413.633C262.834 421.457 243.279 425.392 223.724 425.392C205.237 425.392 186.728 421.889 169.242 414.861L166.195 413.633L163.489 395.914L173.04 387.543L165.695 380.833L165.559 364.866L172.198 358.201C172.198 358.201 170.493 333.704 169.924 323.627C193.663 345.668 272.611 355.995 272.611 355.995L272.588 356.017Z"
                      fill="#B3836F"
                    />
                    <path
                      d="M184.5 158.197C185.819 161.359 186.91 164.634 187.797 167.955C188.843 171.958 189.275 176.94 186.069 179.533C185.637 179.874 185.159 180.17 184.613 180.238C184.068 180.306 182.249 181.489 181.748 181.239C177.883 179.351 178.224 172.936 175.518 169.593C174.404 168.228 172.994 167.136 171.948 165.726C170.607 163.929 170.47 161.905 169.924 159.721C167.742 151.078 166.309 141.615 168.969 133.108C171.63 124.602 178.474 117.004 187.251 115.389C187.979 115.253 188.752 115.162 189.411 114.821C191.253 113.911 192.003 112.023 192.799 110.135C194.459 106.155 200.485 101.628 204.737 100.787C208.989 99.9451 208.534 100.354 212.832 100.4C215.697 100.423 221.336 102.811 223.223 105.131C224.61 106.837 221.359 104.585 223.564 104.585C238.208 104.54 247.235 112.546 250.987 121.281C251.919 123.464 252.579 125.83 252.488 128.218C252.351 131.653 252.033 135.997 250.896 139.25C252.01 142.116 252.783 144.777 253.988 147.939C255.194 151.1 253.897 154.399 251.601 156.878C250.396 158.152 250.35 159.448 248.668 159.994C227.976 166.772 204.919 167.432 186.478 179.032"
                      fill="#8E6B4A"
                    />
                    <path
                      d="M210.467 168.228C202.236 170.412 194.277 173.232 187.024 177.736C186.819 178.009 187.024 178.737 186.751 178.964C186.319 179.305 184.318 180.875 183.772 180.92C183.204 180.988 182.431 180.42 181.908 180.192C178.042 178.304 178.383 171.89 175.677 168.546C174.563 167.182 169.424 170.252 168.378 168.842C167.037 167.045 166.9 163.406 166.946 161.154C167.241 150.6 166.445 140.569 169.129 132.085C171.743 123.76 178.679 117.596 187.16 115.753C189.388 117.528 190.935 118.369 192.208 120.939C195.619 127.786 193.754 135.929 194.505 143.526C195.505 153.648 201.735 163.019 210.444 168.251L210.467 168.228Z"
                      fill="#896649"
                    />
                    <path
                      d="M249.145 154.694C253.92 153.966 258.377 157.265 259.105 162.041C259.787 166.613 256.808 170.912 252.351 171.89"
                      fill="#FFB999"
                    />
                    <path
                      d="M174.404 185.083C179.264 185.083 183.204 180.571 183.204 175.006C183.204 169.441 179.264 164.93 174.404 164.93C169.544 164.93 165.604 169.441 165.604 175.006C165.604 180.571 169.544 185.083 174.404 185.083Z"
                      fill="#FFB999"
                    />
                    <path
                      d="M176.405 182.558C180.185 182.558 183.249 179.055 183.249 174.733C183.249 170.412 180.185 166.909 176.405 166.909C172.625 166.909 169.561 170.412 169.561 174.733C169.561 179.055 172.625 182.558 176.405 182.558Z"
                      fill="#F57A59"
                    />
                    <path
                      d="M247.349 148.075L252.124 171.595C253.511 178.418 253.875 185.424 252.806 192.293C250.418 207.942 242.21 218.474 227.134 221.544C218.516 223.296 210.012 220.771 202.804 216.176C192.299 209.512 185.227 198.571 182.749 186.379L181.703 181.216C181.703 181.216 188.502 181.102 188.752 174.006C189.002 166.909 183.886 158.038 183.886 158.038L186.091 161.973L193.504 159.949L197.915 156.082L200.917 151.715L206.488 154.376L214.287 153.898L219.972 150.214L224.588 155.081L232.182 156.855L239.004 154.376L247.349 148.053V148.075Z"
                      fill="#FFB999"
                    />
                    <path
                      d="M241.937 215.062C238.094 218.337 233.319 220.612 227.521 221.794C225.656 222.181 223.792 222.34 221.95 222.34C215.288 222.34 208.83 220.02 203.191 216.426C192.708 209.762 185.614 198.821 183.158 186.629L182.112 181.466C182.112 181.466 187.979 181.352 189.002 175.643C193.527 196.547 199.348 204.599 207.534 210.603C216.083 216.881 225.315 216.768 231.955 216.768C233.797 216.768 235.661 216.586 237.549 216.199C239.095 215.881 240.573 215.494 241.96 215.016L241.937 215.062Z"
                      fill="#F57A59"
                    />
                    <path
                      d="M235.479 156.173C235.479 156.173 252.488 150.1 252.647 129.697"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M167.332 143.094C165.718 154.967 166.582 163.133 167.992 167.887"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M174.404 185.083C179.264 185.083 183.204 180.571 183.204 175.006C183.204 169.441 179.264 164.93 174.404 164.93C169.544 164.93 165.604 169.441 165.604 175.006C165.604 180.571 169.544 185.083 174.404 185.083Z"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M173.312 169.707C173.312 169.707 168.992 173.278 172.357 179.715"
                      stroke="#232144"
                      strokeWidth="0.68"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M171.13 174.256C171.13 174.256 174.086 174.074 175.745 176.735"
                      stroke="#232144"
                      strokeWidth="0.68"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M254.398 163.975C254.398 163.975 254.352 161.382 251.942 160.153"
                      stroke="#232144"
                      strokeWidth="0.59"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M249.145 154.694C253.92 153.966 258.377 157.265 259.105 162.041C259.787 166.613 256.808 170.912 252.351 171.89"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M250.76 140.433C250.76 140.433 256.308 146.369 253.42 155.126"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M212.013 236.443V220.543"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M233.024 240.241C229.226 246.155 218.335 245.45 213.355 238.899"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M233.592 220.543V236.443"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M233.592 233.622H234.047C236.275 233.622 238.458 233.986 240.573 234.691C253.807 239.149 304.854 257.392 340.463 283.959"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M332.663 278.454C332.663 278.454 373.297 235.715 381.847 213.492C381.847 213.492 390.965 223 401.22 223.364L356.493 309.138C354.561 312.869 350.308 314.757 346.238 313.71L278.546 296.31"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M278.523 287.598V316.303C278.523 317.031 278.387 317.782 278.137 318.464L271.884 335.546C271.633 336.229 271.497 336.979 271.497 337.707L274.18 381.811"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M149.028 273.336L160.488 265.717L189.525 241.674L212.013 233.622"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M167.742 304.999L164.149 307.114C150.415 315.189 134.771 319.442 118.854 319.442H109.759L48.7285 230.028C48.7285 230.028 62.2806 235.988 71.5124 228.254L131.519 284.982L145.321 275.793"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M284.299 459.693L280.433 418.478"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M290.938 530.91L284.958 466.767"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M216.402 541.532L227.635 466.721L247.758 533.594L263.334 592.824L268.655 630.81C268.655 630.81 280.433 639.544 300.17 627.011L291.598 538.007"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M169.811 547.401L168.378 625.919C168.378 625.919 176.359 640.522 202.554 631.037L215.219 549.334"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M169.674 528.454L169.606 540.873"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M170.516 416.385L169.606 522.79"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M215.106 421.002V446.842L231.568 459.761"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M221.677 432.648V435.56"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M221.677 440.382V443.27"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M265.79 432.648C265.79 432.648 263.47 450.89 286.777 450.89"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M187.046 432.648C187.046 432.648 189.366 450.89 166.059 450.89"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M274.453 633.175L278.455 647.733C278.91 649.416 280.342 650.69 282.093 650.872C284.867 651.167 289.119 650.963 292.439 648.051C293.508 647.119 294.008 645.663 293.826 644.253L292.03 631.219"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M182.681 633.994V645.504C182.681 645.504 188.775 649.803 194.846 645.504V633.266"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M208.739 235.374C208.739 242.334 215.515 247.952 223.883 247.952C232.25 247.952 239.026 242.311 239.026 235.374V234.691"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M396.672 222.636L405.517 203.916L414.636 190.997L416.159 178.35L409.565 168.706L406.404 166.181H396.672"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M384.484 215.858V171.89L399.196 138.568"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M405.881 145.664L394.603 170.48"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M400.924 136.748C400.924 136.748 404.381 133.905 406.404 136.748C408.428 139.591 407.086 143.299 407.086 143.299"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M179.202 638.452C175.177 640.204 172.517 643.206 172.517 646.618C172.517 652.032 179.247 656.422 187.569 656.422C195.892 656.422 202.622 652.032 202.622 646.618C202.622 643.684 200.644 641.045 197.483 639.249"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M152.689 689.13C146.617 688.379 140.683 686.742 135.112 684.217C133.361 680.396 134.225 675.846 137.317 672.98C143.843 666.907 156.577 656.945 174.563 651.508"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M202.304 649.12L204.169 670.205C204.464 673.617 203.827 677.029 202.304 680.1C190.207 684.376 177.678 687.288 164.922 688.766"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <g className="frame1-about frame1-about_type2">
                      <g opacity="0.58">
                        <path
                          d="M93.9553 480.005C108.221 480.005 119.786 468.436 119.786 454.166C119.786 439.895 108.221 428.326 93.9553 428.326C79.6893 428.326 68.1244 439.895 68.1244 454.166C68.1244 468.436 79.6893 480.005 93.9553 480.005Z"
                          fill="#E0F3FC"
                        />
                        <path
                          d="M92.4318 465.152C91.8406 465.152 91.2494 464.993 90.7264 464.697L77.811 457.1C76.2193 456.167 75.6736 454.097 76.6286 452.505C77.5609 450.913 79.6301 450.367 81.2218 451.322L91.1585 457.168L99.7309 441.678C100.64 440.063 102.687 439.472 104.301 440.359C105.916 441.269 106.507 443.316 105.62 444.931L95.3651 463.423C94.9331 464.219 94.1827 464.788 93.3186 465.038C93.023 465.106 92.7274 465.152 92.4318 465.152Z"
                          fill="#E0F3FC"
                        />
                      </g>
                      <path
                        d="M93.5233 466.608C92.9321 466.608 92.3409 466.448 91.8179 466.153L78.9024 458.556C77.3107 457.623 76.765 455.553 77.72 453.961C78.6523 452.369 80.7215 451.823 82.3132 452.778L92.2499 458.624L100.822 443.134C101.732 441.519 103.778 440.928 105.393 441.815C107.007 442.725 107.598 444.772 106.712 446.387L96.4565 464.879C96.0245 465.675 95.2741 466.244 94.4101 466.494C94.1145 466.562 93.8189 466.608 93.5233 466.608Z"
                        fill="#84ECFF"
                      />
                      <path
                        d="M71.3306 446.023C71.3306 446.023 77.6973 429.396 95.4561 430.055"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M93.9553 480.005C108.221 480.005 119.786 468.436 119.786 454.166C119.786 439.895 108.221 428.326 93.9553 428.326C79.6893 428.326 68.1244 439.895 68.1244 454.166C68.1244 468.436 79.6893 480.005 93.9553 480.005Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M93.7734 466.494C93.1822 466.494 92.591 466.335 92.068 466.039L79.1526 458.442C77.5609 457.509 77.0151 455.439 77.9702 453.847C78.9024 452.255 80.9716 451.709 82.5633 452.664L92.5 458.51L101.072 443.02C101.982 441.405 104.028 440.814 105.643 441.701C107.257 442.611 107.848 444.658 106.962 446.273L96.7066 464.765C96.2746 465.561 95.5242 466.13 94.6602 466.38C94.3646 466.448 94.069 466.494 93.7734 466.494Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <g className="frame1-about frame1-about_type3">
                      <path
                        d="M304.741 164.27C319.007 164.27 330.572 152.702 330.572 138.431C330.572 124.16 319.007 112.592 304.741 112.592C290.475 112.592 278.91 124.16 278.91 138.431C278.91 152.702 290.475 164.27 304.741 164.27Z"
                        fill="#29FC97"
                      />
                      <path
                        d="M330.572 139.204C330.572 148.849 325.319 157.242 317.52 161.677C320.498 157.469 322.227 152.329 322.227 146.801C322.227 132.517 310.653 120.962 296.396 120.962C291.757 120.962 287.391 122.191 283.639 124.329C288.301 117.687 296.009 113.342 304.763 113.342C319.043 113.342 330.594 124.92 330.594 139.182L330.572 139.204Z"
                        fill="#9CF7C9"
                      />
                      <path
                        d="M303.217 149.417C302.626 149.417 302.035 149.258 301.512 148.962L288.596 141.365C287.005 140.433 286.459 138.363 287.414 136.771C288.346 135.178 290.415 134.632 292.007 135.588L301.944 141.433L310.516 125.944C311.426 124.329 313.472 123.737 315.087 124.624C316.701 125.534 317.292 127.581 316.406 129.196L306.15 147.689C305.718 148.485 304.968 149.053 304.104 149.304C303.808 149.372 303.513 149.417 303.217 149.417Z"
                        fill="#29FC97"
                      />
                      <path
                        d="M304.309 150.873C303.717 150.873 303.126 150.714 302.603 150.418L289.688 142.821C288.096 141.888 287.55 139.818 288.505 138.226C289.438 136.634 291.507 136.088 293.099 137.043L303.035 142.889L311.608 127.399C312.517 125.784 314.564 125.193 316.178 126.08C317.793 126.99 318.384 129.037 317.497 130.652L307.242 149.144C306.81 149.94 306.06 150.509 305.195 150.759C304.9 150.827 304.604 150.873 304.309 150.873Z"
                        fill="white"
                      />
                      <path
                        d="M282.139 130.288C282.139 130.288 288.505 113.661 306.264 114.32"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M304.741 164.27C319.007 164.27 330.572 152.702 330.572 138.431C330.572 124.16 319.007 112.592 304.741 112.592C290.475 112.592 278.91 124.16 278.91 138.431C278.91 152.702 290.475 164.27 304.741 164.27Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M304.559 150.759C303.968 150.759 303.376 150.6 302.853 150.304L289.938 142.707C288.346 141.775 287.801 139.705 288.756 138.113C289.688 136.52 291.757 135.974 293.349 136.93L303.285 142.775L311.858 127.286C312.767 125.671 314.814 125.079 316.428 125.966C318.043 126.876 318.634 128.923 317.747 130.538L307.492 149.031C307.06 149.827 306.31 150.395 305.446 150.646C305.15 150.714 304.854 150.759 304.559 150.759Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <path
                      d="M53.5946 231.507C53.0034 216.904 36.4725 203.802 36.4725 203.802V192.407C36.4725 192.407 37.6095 186.334 43.4305 184.673"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M60.257 213.674C60.257 213.674 67.5105 221.522 70.3528 229.119"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M62.7582 216.631L65.3049 190.246L42.2936 158.334"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M36.5408 163.406L47.5917 186.061"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M35.1992 160.108C35.1992 160.108 34.5625 157.196 36.4725 155.809"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M38.5872 155.354C38.5872 155.354 39.1101 154.785 40.6791 156.559"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M199.734 143.89C199.689 145.96 200.849 147.984 202.668 148.962C203.304 149.304 203.873 148.325 203.236 147.984C201.735 147.165 200.826 145.55 200.871 143.89C200.871 143.162 199.757 143.162 199.734 143.89Z"
                      fill="#232144"
                    />
                    <path
                      d="M244.87 144.823C245.234 144.299 245.53 143.708 245.712 143.094C245.803 142.821 245.598 142.457 245.325 142.389C245.007 142.321 244.734 142.48 244.62 142.775C244.575 142.957 244.507 143.117 244.438 143.276L244.507 143.139C244.347 143.526 244.143 143.89 243.893 144.231C243.802 144.345 243.802 144.55 243.824 144.663C243.847 144.777 243.961 144.936 244.075 145.005C244.211 145.073 244.37 145.118 244.507 145.073C244.643 145.027 244.757 144.936 244.848 144.823H244.87Z"
                      fill="#232144"
                    />
                    <path
                      d="M173.472 131.744C172.676 132.79 172.062 133.973 171.743 135.247C171.675 135.542 171.834 135.884 172.13 135.952C172.426 136.02 172.744 135.861 172.835 135.565C172.903 135.269 172.994 134.996 173.085 134.701C173.131 134.564 173.199 134.428 173.244 134.291C173.199 134.382 173.29 134.178 173.29 134.178C173.312 134.109 173.335 134.064 173.381 133.996C173.517 133.745 173.653 133.472 173.79 133.245C173.858 133.109 173.949 132.995 174.04 132.858C174.086 132.79 174.131 132.745 174.176 132.676C174.176 132.676 174.313 132.494 174.267 132.563C174.449 132.335 174.518 131.994 174.267 131.767C174.063 131.585 173.653 131.516 173.472 131.767V131.744Z"
                      fill="#232144"
                    />
                    <path
                      d="M172.994 158.22C171.243 151.919 170.788 145.323 171.698 138.84C171.789 138.135 170.698 137.817 170.607 138.545C169.652 145.232 170.084 152.01 171.903 158.538C172.107 159.243 173.199 158.948 172.994 158.243V158.22Z"
                      fill="#232144"
                    />
                    <g className="frame1-about-shake">
                      <path
                        d="M431.144 94.2606L388.934 106.52C387.293 106.996 386.35 108.712 386.826 110.353L397.319 146.505C397.795 148.145 399.511 149.089 401.151 148.613L443.361 136.354C445.001 135.877 445.945 134.161 445.469 132.52L434.976 96.3688C434.5 94.7281 432.784 93.7842 431.144 94.2606Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <path
                      d="M223.36 148.462C225.52 151.533 229.817 152.488 233.387 152.306C235.343 152.215 237.298 151.692 238.981 150.646C240.755 149.554 242.21 147.984 243.62 146.483C244.12 145.96 243.324 145.141 242.824 145.687C240.209 148.439 237.617 150.873 233.638 151.146C230.477 151.373 226.316 150.668 224.338 147.871C223.928 147.279 222.928 147.848 223.36 148.439V148.462Z"
                      fill="#232144"
                    />
                    <path
                      d="M245.575 502.41L242.847 493.448"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M244.37 506.231L241.641 497.269"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M272.748 298.107L272.247 288.735"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M270.86 301.564L270.156 292.215"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M321.408 302.997L330.412 305.635"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M318.77 300.063L327.82 302.497"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M175.814 578.631L176.268 569.26"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M173.403 581.815L173.858 572.467"
                      stroke="#232144"
                      strokeWidth="0.47"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M243.846 128.279C246.148 125.44 246.298 121.746 244.181 120.029C242.065 118.312 238.483 119.222 236.181 122.061C233.88 124.901 233.729 128.594 235.846 130.311C237.963 132.028 241.544 131.118 243.846 128.279Z"
                      fill="#987960"
                    />
                    <path
                      d="M240.624 136.644C242.035 136.232 242.93 135.048 242.625 133.999C242.319 132.95 240.927 132.433 239.517 132.844C238.106 133.255 237.211 134.439 237.516 135.489C237.822 136.538 239.213 137.055 240.624 136.644Z"
                      fill="#987960"
                    />
                    <path
                      d="M190.844 180.147C192.299 177.827 192.822 174.756 192.64 172.049C192.436 168.865 191.731 165.18 190.23 162.36L188.866 165.703C191.685 165.044 194.573 164.27 197.051 162.701C199.757 160.995 201.758 158.493 203.054 155.581C203.555 154.467 203.373 153.148 202.236 152.465C201.258 151.897 199.644 152.147 199.121 153.284C198.097 155.581 196.71 157.606 194.505 158.925C192.299 160.244 190.002 160.767 187.66 161.313C186.182 161.654 185.637 163.406 186.296 164.657C186.865 165.749 187.115 167 187.388 168.183C187.706 169.456 188.002 170.753 188.092 172.049C188.229 174.005 187.956 176.166 186.91 177.85C185.364 180.329 189.275 182.626 190.821 180.147H190.844Z"
                      fill="#F57A59"
                    />
                    <path
                      d="M253.352 181.284C253.534 184.969 253.352 188.654 252.806 192.293C250.418 207.942 242.21 218.474 227.134 221.544C218.516 223.296 210.012 220.771 202.804 216.176C192.299 209.512 185.227 198.571 182.749 186.379L181.703 181.216C181.703 181.216 188.502 181.102 188.752 174.005C189.002 166.909 183.886 158.038 183.886 158.038"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M198.279 109.794C200.326 106.814 203.759 104.972 207.306 104.472C211.536 103.857 215.811 105.245 219.358 107.474C221.836 109.021 224.11 105.108 221.654 103.562C217.107 100.696 211.695 99.2627 206.351 100.059C201.508 100.787 197.142 103.493 194.368 107.519C193.663 108.52 194.186 110.044 195.187 110.636C196.324 111.295 197.597 110.84 198.302 109.817L198.279 109.794Z"
                      fill="#987960"
                    />
                    <path
                      d="M199.553 108.27C199.848 107.974 200.167 107.679 200.485 107.406C200.576 107.337 200.644 107.269 200.735 107.201C201.144 106.86 200.462 107.406 200.712 107.201C200.894 107.087 201.053 106.951 201.235 106.837C201.963 106.337 202.713 105.905 203.509 105.541C203.6 105.495 203.691 105.45 203.805 105.404C204.078 105.268 203.805 105.427 203.691 105.45C203.873 105.45 204.1 105.29 204.282 105.222C204.691 105.086 205.078 104.949 205.487 104.835C205.919 104.722 206.351 104.608 206.806 104.54C207.011 104.494 207.215 104.472 207.443 104.426C207.761 104.381 206.988 104.472 207.306 104.426C207.443 104.426 207.579 104.403 207.693 104.381C208.307 104.312 208.853 104.176 209.307 103.721C209.694 103.334 209.99 102.675 209.967 102.106C209.921 100.969 208.966 99.7176 207.693 99.8314C203.441 100.264 199.416 101.969 196.369 104.995C195.528 105.836 195.46 107.383 196.369 108.202C197.279 109.021 198.689 109.089 199.575 108.202L199.553 108.27Z"
                      fill="#C5A58A"
                    />
                    <path
                      d="M228.271 111.227C228.271 111.227 223.451 100.969 210.353 100.468"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M207.898 100.445C194.323 100.445 190.525 114.798 190.525 114.798C190.525 114.798 167.833 117.846 167.833 138.545"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M230.613 109.658C232.046 110.044 233.501 110.454 234.888 110.954C235.07 111.022 235.252 111.091 235.434 111.159C235.525 111.204 235.616 111.227 235.707 111.273C235.388 111.136 235.343 111.113 235.57 111.204C235.866 111.341 236.184 111.477 236.48 111.636C237.162 111.978 237.821 112.364 238.435 112.819C238.89 113.138 239.663 113.183 240.186 113.047C240.709 112.91 241.278 112.501 241.55 112C242.164 110.84 241.778 109.635 240.732 108.884C238.094 107.019 234.934 106.109 231.841 105.268C230.704 104.949 229.317 105.654 229.044 106.86C228.771 108.065 229.408 109.316 230.636 109.658H230.613Z"
                      fill="#987960"
                    />
                    <path
                      d="M234.138 105.95C230.886 104.858 227.089 104.335 222.7 104.631"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M252.238 125.625C252.238 125.625 250.055 113.092 237.526 107.36"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M232.228 120.803C230.909 121.667 229.908 123.032 229.522 124.579C229.317 125.375 229.249 126.217 229.022 126.99C228.635 128.286 227.794 129.424 226.657 130.152C225.838 130.675 224.792 130.97 223.86 130.697C223.155 130.47 222.587 129.947 222.064 129.424C221.109 128.491 220.063 127.354 220.222 126.035C220.313 125.375 220.677 124.806 221.04 124.26C221.768 123.146 222.518 122.009 223.246 120.894C224.315 119.279 225.452 117.573 227.225 116.754C228.794 116.049 230.613 116.14 232.25 116.686C233.547 117.118 234.934 118.119 234.865 119.507C234.797 120.735 233.592 121.576 232.478 122.122C231.477 122.6 230.454 122.987 229.385 123.282"
                      fill="#987960"
                    />
                    <path
                      d="M169.72 300.404C169.72 300.7 172.085 330.224 172.085 330.224"
                      stroke="#A97763"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M174.017 308.001C174.017 308.297 176.382 337.821 176.382 337.821"
                      stroke="#A97763"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M167.741 297.129L172.312 357.928"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M201.485 156.696C205.01 158.425 208.784 159.084 212.673 158.447C215.879 157.924 219.199 156.491 221.382 154.012C222.2 153.102 222.291 151.715 221.382 150.805C220.563 149.986 218.994 149.872 218.175 150.805C216.516 152.67 214.264 153.58 211.718 154.035C209.33 154.467 206.238 153.989 203.782 152.784C202.691 152.238 201.326 152.488 200.667 153.602C200.076 154.603 200.371 156.173 201.485 156.719V156.696Z"
                      fill="#F57A59"
                    />
                    <path
                      d="M217.357 154.148C220.017 158.88 225.224 161.518 230.613 161.268C231.796 161.2 232.933 160.267 232.887 158.993C232.842 157.81 231.887 156.673 230.613 156.719C230.045 156.741 229.499 156.741 228.931 156.719C228.794 156.719 228.658 156.719 228.521 156.673C228.317 156.673 228.089 156.514 228.544 156.673C228.294 156.582 227.998 156.582 227.748 156.537C227.248 156.423 226.748 156.287 226.27 156.127C226.134 156.082 226.02 156.036 225.884 155.991C225.816 155.968 225.406 155.763 225.702 155.923C225.997 156.082 225.565 155.854 225.543 155.832C225.429 155.763 225.315 155.718 225.179 155.65C224.724 155.422 224.292 155.149 223.883 154.876C223.883 154.876 223.428 154.581 223.724 154.763C224.019 154.945 223.633 154.694 223.587 154.649C223.383 154.467 223.178 154.308 222.996 154.103C222.814 153.898 222.609 153.716 222.428 153.512C222.359 153.421 222.291 153.352 222.223 153.261C222.177 153.193 222.109 153.148 222.064 153.079C221.95 152.943 221.996 152.988 222.155 153.216C222.155 153.102 221.791 152.715 221.723 152.602C221.564 152.351 221.404 152.079 221.245 151.806C220.654 150.782 219.153 150.327 218.13 150.987C217.107 151.646 216.697 152.988 217.311 154.103L217.357 154.148Z"
                      fill="#F57A59"
                    />
                    <path
                      d="M212.013 154.399C212.013 154.399 219.54 154.057 221.063 145.732"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M219.972 149.053C219.972 149.053 221.814 157.219 232.205 156.878"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M197.256 142.116C197.256 142.116 197.006 154.399 208.898 154.399"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M180.293 353.493L168.014 365.775L168.151 380.287L175.996 387.816L165.49 396.937L168.219 412.2C168.219 412.2 186.819 420.547 210.763 423.027"
                      stroke="#9D6C58"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M187.423 679.411C190.523 678.843 192.807 677.13 192.524 675.585C192.241 674.041 189.498 673.25 186.398 673.818C183.297 674.387 181.013 676.1 181.297 677.645C181.58 679.189 184.322 679.98 187.423 679.411Z"
                      fill="#1E3C51"
                    />
                    <path
                      d="M192.413 673.299C192.94 673.299 193.368 672.871 193.368 672.343C193.368 671.816 192.94 671.388 192.413 671.388C191.885 671.388 191.458 671.816 191.458 672.343C191.458 672.871 191.885 673.299 192.413 673.299Z"
                      fill="#1E3C51"
                    />
                    <path
                      d="M198.143 676.529C198.959 676.529 199.621 675.867 199.621 675.05C199.621 674.234 198.959 673.572 198.143 673.572C197.327 673.572 196.665 674.234 196.665 675.05C196.665 675.867 197.327 676.529 198.143 676.529Z"
                      fill="#1E3C51"
                    />
                    <path
                      d="M175.495 681.169C177.643 681.169 179.384 679.427 179.384 677.279C179.384 675.131 177.643 673.39 175.495 673.39C173.348 673.39 171.607 675.131 171.607 677.279C171.607 679.427 173.348 681.169 175.495 681.169Z"
                      fill="#1E3C51"
                    />
                    <path
                      d="M282.775 660.902C282.775 660.902 289.665 662.745 296.009 658.56"
                      stroke="#1E3C51"
                      strokeWidth="1.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M294.099 639.84C298.124 641.796 300.784 645.094 300.784 648.847C300.784 654.829 294.054 659.697 285.731 659.697C277.409 659.697 270.678 654.829 270.678 648.847C270.678 645.595 272.657 642.683 275.817 640.681"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M327.797 694.043C334.778 693.202 341.6 691.291 348.035 688.379C350.058 683.967 349.058 678.735 345.511 675.437C337.78 668.249 322.477 656.308 300.784 650.189"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M271.975 654.193L272.52 675.756C272.202 678.189 273.043 680.6 274.771 682.329C275.635 683.193 276.659 683.83 277.796 684.24C291.166 688.834 299.625 691.973 313.7 693.611"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M318.406 694.157L322.977 694.407"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M223.451 169.32C223.451 167.398 221.893 165.84 219.972 165.84C218.05 165.84 216.493 167.398 216.493 169.32V173.505C216.493 175.427 218.05 176.985 219.972 176.985C221.893 176.985 223.451 175.427 223.451 173.505V169.32Z"
                      fill="#232144"
                    />
                    <path
                      d="M223.087 172.14C223.853 172.14 224.474 171.519 224.474 170.753C224.474 169.986 223.853 169.365 223.087 169.365C222.321 169.365 221.7 169.986 221.7 170.753C221.7 171.519 222.321 172.14 223.087 172.14Z"
                      fill="white"
                    />
                    <g className="frame1-about-blink">
                      <path
                        d="M244.757 165.499C244.757 163.577 243.199 162.018 241.278 162.018C239.356 162.018 237.799 163.577 237.799 165.499V169.684C237.799 171.606 239.356 173.164 241.278 173.164C243.199 173.164 244.757 171.606 244.757 169.684V165.499Z"
                        fill="#232144"
                      />
                    </g>
                    <path
                      d="M244.37 168.296C245.136 168.296 245.757 167.675 245.757 166.909C245.757 166.142 245.136 165.521 244.37 165.521C243.604 165.521 242.983 166.142 242.983 166.909C242.983 167.675 243.604 168.296 244.37 168.296Z"
                      fill="white"
                    />
                    <path
                      d="M208.784 243.994C210.012 245.746 211.718 247.156 213.673 247.998C213.946 248.111 214.287 248.089 214.446 247.793C214.583 247.543 214.537 247.133 214.242 247.02C212.445 246.246 210.876 245.018 209.739 243.426C209.557 243.176 209.239 243.062 208.966 243.221C208.716 243.357 208.58 243.744 208.762 243.994H208.784Z"
                      fill="#232144"
                    />
                    <path
                      d="M234.638 247.861C235.98 246.974 237.253 245.973 238.413 244.836C238.64 244.631 238.617 244.245 238.413 244.04C238.208 243.835 237.821 243.835 237.617 244.04C236.503 245.109 235.343 246.042 234.07 246.883C233.819 247.042 233.706 247.384 233.865 247.656C234.024 247.907 234.388 248.02 234.638 247.861Z"
                      fill="#232144"
                    />
                    <path
                      d="M221.404 250.727C222.996 251.182 224.701 251.182 226.27 250.727C226.975 250.522 226.68 249.431 225.975 249.635C224.565 250.045 223.11 250.045 221.7 249.635C220.995 249.431 220.699 250.522 221.404 250.727Z"
                      fill="#232144"
                    />
                    <path
                      d="M248.918 385.405H262.584L273.725 382.88"
                      stroke="#9D6C58"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M248.781 383.767H262.697L275.022 380.856L280.934 386.292L282.798 394.435"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M256.763 404.921L265.244 404.534L273.339 401.759L284.367 395.55"
                      stroke="#9D6C58"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M180.407 350.331L165.718 365.025V380.856L173.062 387.566L163.512 395.914L166.218 413.655L169.265 414.884C205.26 429.35 245.507 428.918 281.184 413.655L289.028 398.962L287.687 391.956L273.339 400.235L265.494 403.01L256.126 403.511"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M52.3439 174.347L61.9395 187.835"
                      stroke="white"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <g className="frame1-about-shake">
                      <path
                        opacity="0.3"
                        d="M23.4206 181.876L67.6014 152.124L45.4996 119.074L0.750366 150.486C0.750366 150.486 18.3499 167.455 23.4206 181.898V181.876Z"
                        fill="#77B7B6"
                      />
                      <path
                        d="M31.2654 129.333L52.7987 162.132"
                        stroke="white"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                      />
                      <path
                        d="M36.8363 125.284L58.3696 158.083"
                        stroke="white"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                      />
                      <path
                        d="M23.4206 181.876L67.6014 152.124L45.4996 119.074L0.750366 150.486C0.750366 150.486 18.3499 167.455 23.4206 181.898V181.876Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <path
                      d="M234.092 181.034L235.798 184.287C237.321 187.198 235.616 190.769 232.41 191.429"
                      stroke="#F57A59"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M241.391 196.683C238.094 199.776 234.433 200.618 230.34 200.186C229.977 200.14 229.636 200.095 229.272 200.049"
                      stroke="#232144"
                      strokeWidth="0.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M245.348 153.716L247.781 165.317C247.963 166.226 249.032 166.75 249.873 166.499C250.805 166.249 251.26 165.317 251.055 164.407L248.622 152.806C248.44 151.897 247.372 151.373 246.53 151.624C245.598 151.874 245.143 152.806 245.348 153.716Z"
                      fill="white"
                    />
                    <path
                      d="M247.349 148.075L252.124 171.594C252.465 173.3 252.761 175.006 252.965 176.735"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <g className="frame1-about frame1-about_type4">
                      <path
                        d="M139.79 209.222L110.942 223.679C110.279 224.011 110.011 224.817 110.343 225.48L122.748 250.249C123.08 250.912 123.886 251.18 124.549 250.848L153.397 236.391C154.059 236.059 154.327 235.253 153.995 234.59L141.59 209.82C141.258 209.158 140.452 208.89 139.79 209.222Z"
                        fill="#FFA744"
                      />
                      <path
                        d="M120.592 245.915L151.839 230.256L153.734 234.038C154.223 235.015 153.817 236.185 152.861 236.664L125.131 250.56C124.156 251.049 122.986 250.643 122.507 249.687L120.613 245.905L120.592 245.915Z"
                        fill="#F97C00"
                      />
                      <path
                        d="M114.193 223.478L130.996 215.039"
                        stroke="#FFDAB6"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M120.4 220.361L124.72 218.201"
                        stroke="white"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M117.649 239.764L114.215 232.94"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M112.555 229.596L110.486 225.457C110.145 224.797 110.418 223.978 111.1 223.637L139.932 209.193C140.592 208.852 141.41 209.125 141.751 209.807L154.144 234.578C154.485 235.237 154.212 236.056 153.53 236.397L124.698 250.841C124.038 251.182 123.22 250.909 122.879 250.227L119.445 243.38"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <g className="frame1-about frame1-about_type3">
                      <path
                        d="M78.6068 333.34H25.9446C23.9227 333.34 22.2837 334.98 22.2837 337.002V369.142C22.2837 371.164 23.9227 372.804 25.9446 372.804H78.6068C80.6287 372.804 82.2677 371.164 82.2677 369.142V337.002C82.2677 334.98 80.6287 333.34 78.6068 333.34Z"
                        fill="#9671C3"
                      />
                      <g className="frame-sun-mirror frame-sun-mirror_obj2">
                        <path
                          d="M48.683 334L33.38 372.895L46.1363 372.986L58.9153 334.045H54.8678C54.8678 334.045 49.0695 333.84 48.7057 334H48.683Z"
                          fill="#EBDEFF"
                        />
                        <path
                          d="M62.3716 334L49.2288 372.895H52.7077L65.8051 333.954H64.6909C64.6909 333.954 62.7581 333.863 62.3943 334.022L62.3716 334Z"
                          fill="#EBDEFF"
                        />
                        <path
                          d="M76.0601 334L62.9172 372.895H66.3962L79.4936 333.954H78.3794C78.3794 333.954 76.4466 333.863 76.0828 334.022L76.0601 334Z"
                          fill="#C6A2F9"
                        />
                      </g>
                      <path
                        d="M45.818 338.844H29.4918V348.921H45.818V338.844Z"
                        fill="white"
                      />
                      <path
                        d="M29.469 354.494H62.2124"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M29.469 359.043H49.7972"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M29.469 363.615H49.7972"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M78.6068 333.34H25.9446C23.9227 333.34 22.2837 334.98 22.2837 337.002V369.142C22.2837 371.164 23.9227 372.804 25.9446 372.804H78.6068C80.6287 372.804 82.2677 371.164 82.2677 369.142V337.002C82.2677 334.98 80.6287 333.34 78.6068 333.34Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M45.818 338.844H29.4918V348.921H45.818V338.844Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <g className="frame1-about frame1-about_type5">
                      <path
                        d="M96.1359 365.065L64.4363 359.045C63.7084 358.907 63.0063 359.385 62.8681 360.113L57.7022 387.331C57.564 388.059 58.0421 388.762 58.77 388.9L90.4696 394.92C91.1975 395.059 91.8996 394.58 92.0378 393.852L97.2037 366.634C97.3419 365.906 96.8638 365.203 96.1359 365.065Z"
                        fill="#FFA744"
                      />
                      <path
                        d="M58.615 382.587L92.9506 389.108L92.1618 393.265C91.9582 394.337 90.9258 395.021 89.8758 394.822L59.4049 389.035C58.3326 388.831 57.6491 387.798 57.8485 386.748L58.6373 382.591L58.615 382.587Z"
                        fill="#F97C00"
                      />
                      <path
                        d="M67.1694 360.862L85.6558 364.365"
                        stroke="#FFDAB6"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M73.991 362.159L78.7433 363.046"
                        stroke="white"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M60.0522 375.897L61.462 368.391"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M62.167 364.752L63.0311 360.203C63.1675 359.475 63.8724 358.997 64.6 359.134L96.2747 365.139C97.0023 365.275 97.4798 365.98 97.3434 366.708L92.1818 393.912C92.0453 394.64 91.3404 395.118 90.6128 394.981L58.9382 388.976C58.2105 388.84 57.733 388.135 57.8695 387.407L59.302 379.878"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <g className="frame1-about frame1-about_type2">
                      <path
                        d="M528.72 52.4253L497.783 61.5922C497.073 61.8027 496.667 62.5495 496.878 63.2601L504.744 89.8237C504.954 90.5343 505.7 90.9397 506.411 90.7292L537.348 81.5623C538.058 81.3518 538.464 80.605 538.253 79.8944L530.387 53.3309C530.177 52.6202 529.43 52.2148 528.72 52.4253Z"
                        fill="#FFA744"
                      />
                      <path
                        d="M503.357 85.1788L536.867 75.2495L538.068 79.306C538.378 80.3528 537.773 81.4335 536.749 81.7372L507.011 90.5488C505.964 90.8589 504.884 90.2538 504.58 89.2288L503.379 85.1723L503.357 85.1788Z"
                        fill="#F97C00"
                      />
                      <path
                        d="M501.019 61.9369L519.051 56.5916"
                        stroke="#FFDAB6"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M507.659 59.958L512.297 58.5933"
                        stroke="white"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M501.542 78.564L499.382 71.2626"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M498.336 67.6916L497.017 63.2561C496.812 62.551 497.222 61.7777 497.926 61.573L528.851 52.4064C529.556 52.2017 530.329 52.6111 530.533 53.3162L538.401 79.8606C538.606 80.5657 538.196 81.3391 537.491 81.5438L506.567 90.7103C505.862 90.9151 505.089 90.5056 504.884 89.8005L502.702 82.4536"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M486.697 56.9659L455.76 66.1328C455.05 66.3433 454.644 67.0901 454.855 67.8007L462.721 94.3642C462.931 95.0749 463.678 95.4803 464.388 95.2698L495.325 86.1029C496.035 85.8924 496.441 85.1456 496.23 84.435L488.364 57.8714C488.154 57.1608 487.408 56.7554 486.697 56.9659Z"
                        fill="#FFA744"
                      />
                      <path
                        d="M461.341 89.7411L494.851 79.8119L496.052 83.8684C496.362 84.9152 495.757 85.9959 494.732 86.2995L464.994 95.1112C463.948 95.4213 462.867 94.8162 462.564 93.7912L461.363 89.7347L461.341 89.7411Z"
                        fill="#F97C00"
                      />
                      <path
                        d="M458.975 66.486L477.007 61.1635"
                        stroke="#FFDAB6"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M465.638 64.5299L470.276 63.1424"
                        stroke="white"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M459.521 83.1359L457.361 75.8118"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M456.292 72.2407L454.974 67.8053C454.769 67.1002 455.178 66.3268 455.883 66.1221L486.807 56.9555C487.512 56.7508 488.285 57.1602 488.49 57.8654L496.357 84.4097C496.562 85.1148 496.153 85.8882 495.448 86.0929L464.524 95.2595C463.819 95.4642 463.046 95.0548 462.841 94.3496L460.658 87.0027"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        opacity="0.51"
                        d="M510.668 1.23103L368.009 43.475C362.374 45.1437 359.158 51.0664 360.826 56.7037L390.729 157.751C392.397 163.388 398.318 166.605 403.953 164.936L546.611 122.692C552.247 121.024 555.463 115.101 553.795 109.464L523.892 8.41666C522.224 2.77938 516.303 -0.437741 510.668 1.23103Z"
                        fill="#E0F3FC"
                      />
                      <path
                        d="M376.822 61.2772L410.77 51.5193"
                        stroke="#ACD9EA"
                        strokeWidth="2.66"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M470.254 33.6638L504.202 23.9058"
                        stroke="#ACD9EA"
                        strokeWidth="2.66"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M510.668 1.23103L368.009 43.475C362.374 45.1437 359.158 51.0664 360.826 56.7037L390.729 157.751C392.397 163.388 398.318 166.605 403.953 164.936L546.611 122.692C552.247 121.024 555.463 115.101 553.795 109.464L523.892 8.41666C522.224 2.77938 516.303 -0.437741 510.668 1.23103Z"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M362.746 63.1196C362.906 63.6883 525.781 14.7165 525.781 14.7165"
                        stroke="#232144"
                        strokeWidth="0.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M372.388 53.6347C373.568 53.6347 374.525 52.6774 374.525 51.4966C374.525 50.3157 373.568 49.3585 372.388 49.3585C371.207 49.3585 370.25 50.3157 370.25 51.4966C370.25 52.6774 371.207 53.6347 372.388 53.6347Z"
                        fill="#232144"
                      />
                      <path
                        d="M379.118 51.7013C380.299 51.7013 381.256 50.744 381.256 49.5632C381.256 48.3823 380.299 47.425 379.118 47.425C377.938 47.425 376.981 48.3823 376.981 49.5632C376.981 50.744 377.938 51.7013 379.118 51.7013Z"
                        fill="#232144"
                      />
                      <path
                        d="M385.871 49.3584C387.052 49.3584 388.009 48.4012 388.009 47.2203C388.009 46.0395 387.052 45.0822 385.871 45.0822C384.691 45.0822 383.734 46.0395 383.734 47.2203C383.734 48.4012 384.691 49.3584 385.871 49.3584Z"
                        fill="#232144"
                      />
                    </g>
                    <path
                      opacity="0.3"
                      d="M299.033 185.674L359.427 167.591"
                      stroke="#77B7B6"
                      strokeWidth="1.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      opacity="0.3"
                      d="M315.041 192.179L375.457 174.096"
                      stroke="#77B7B6"
                      strokeWidth="1.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M186.091 161.996C186.091 161.996 195.096 162.883 200.917 151.737"
                      stroke="#232144"
                      strokeWidth="0.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_153_98">
                      <rect width="555" height="697" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Parallax>
            </div>

            <div className="about-article-parrent">
              <div className="about__article article">
                <img
                  src={blueRing50}
                  alt=""
                  className="about__decor about__decor-blue anim-circle-type1"
                />
                <img
                  src={orangeRing25}
                  alt=""
                  className="about__decor about__decor-orange anim-circle-type2"
                />
                <img
                  src={greenRing50two}
                  alt=""
                  className="about__decor about__decor-green anim-circle-type3"
                />

                <img src={uaFlag} alt="ukranine flag" className="about__flag" />
                <AboutQoute />

                <div className="article__bottom">
                  <div className="article__bottom-decor">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        id="Arrow 6"
                        d="M21.0607 3.06066C21.6464 2.47487 21.6464 1.52513 21.0607 0.93934C20.4749 0.353553 19.5251 0.353553 18.9393 0.93934L21.0607 3.06066ZM0.5 20C0.5 20.8284 1.17157 21.5 2 21.5L15.5 21.5C16.3284 21.5 17 20.8284 17 20C17 19.1716 16.3284 18.5 15.5 18.5H3.5V6.5C3.5 5.67157 2.82843 5 2 5C1.17157 5 0.5 5.67157 0.5 6.5L0.5 20ZM18.9393 0.93934L0.93934 18.9393L3.06066 21.0607L21.0607 3.06066L18.9393 0.93934Z"
                        fill="#252525"
                      />
                    </svg>
                  </div>
                  <p className="about__paragraph">
                    I aspire to craft and introduce an exceptional product that
                    not only intrigues users but also sets new standards,
                    outclassing the competition.
                  </p>
                  <Button text="More" href="about" label="about me" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main__portfolio portfolio">
        <Parallax speed={8}>
          <SectionHeader title="portfolio" />
        </Parallax>
        <div className="portfolio__container-big">
          <RecentWorks
            projects={projects}
            modal={modal}
            setModal={setModal}
            label={true}
          />
        </div>
      </section>

      <Reviews home={true} />
    </div>
  );
}

export default Home;
